const baseURL = `${process.env.VUE_APP_SERVER_URL}/RedeCredenciada`;
const buscaRedebaseURL = `${process.env.VUE_APP_SERVER_URL}/busca-rede/v2`;
import * as geoUtils from "@/utils/geoDistance";
import { getStorageData } from "@/utils/storageUtil";

export async function ObterLimiteExames({ vinculo }) {
  return globalThis.window.$axios
    .get({
      url: `${baseURL}/ObterLimiteExames`,
      query: {
        vinculo
      }
    })
    .then(resp => resp.data)
    .catch(error => {
      globalThis.window.$log.error("ObterLimiteExames", error.message);
      return error;
    });
}

export async function BuscarEnderecoReferencia({ vinculo, tipoEndereco, latitude, longitude }) {
  return globalThis.window.$axios
    .get({
      url: `${baseURL}/BuscarEnderecoReferencia`,
      query: {
        vinculo,
        tipoEndereco,
        latitude,
        longitude
      }
    })
    .then(resp => resp.data)
    .catch(error => {
      globalThis.window.$log.error("BuscarEnderecoReferencia", error.message);
      return error;
    });
}

export async function BuscarEnderecoReferenciaV2({ vinculo, tipoEndereco }) {
  let coords: any = null;
  if (!tipoEndereco || (tipoEndereco !== "C" && tipoEndereco !== "R")) {
    tipoEndereco = "";
    coords = await geoUtils.GetLocation().catch(() => null);
  }
  return globalThis.window.$axios
    .get({
      url: `${baseURL}/BuscarEnderecoReferenciaV2`,
      query: {
        vinculo,
        tipoEndereco,
        latitude: coords?.latitude,
        longitude: coords?.longitude
      }
    })
    .then(resp => resp.data)
    .catch(error => {
      globalThis.window.$log.error("BuscarEnderecoReferenciaV2", error.message);
      return error;
    });
}

export async function BuscarPelaProximidadeAtual({
  rede,
  tipoAtendimento,
  codigoEspecialidade,
  subEspecialidade,
  latitude,
  longitude,
  inativos,
  vinculo
}) {
  const query = {
    rede,
    tipoAtendimento,
    codigoEspecialidade,
    subEspecialidade,
    latitude,
    longitude,
    inativos
  };
  if (vinculo) query["vinculo"] = vinculo;
  return globalThis.window.$axios
    .get({
      url: `${baseURL}/BuscarPelaProximidadeAtual`,
      query
    })
    .then(resp => resp.data)
    .catch(error => {
      globalThis.window.$log.error("BuscarPelaProximidadeAtual", error.message);
      return error;
    });
}

export async function BuscarPorProximidade({
  vinculo,
  rede,
  tipoAtendimento,
  codigoEspecialidade,
  subEspecialidade,
  buscaProximidadeTipo,
  inativos
}) {
  const query = {
    rede,
    tipoAtendimento,
    codigoEspecialidade,
    subEspecialidade,
    buscaProximidadeTipo,
    inativos
  };
  if (vinculo) query["vinculo"] = vinculo;
  return globalThis.window.$axios
    .get({
      url: `${baseURL}/BuscarPorProximidade`,
      query
    })
    .then(resp => resp.data)
    .catch(error => {
      globalThis.window.$log.error("BuscarPorProximidade", error.message);
      return error;
    });
}

export async function DetalhePrestador({ vinculo, rede, codigoPrestador, srEndereco, inativos, completo }) {
  const query = {
    rede,
    codigoPrestador,
    srEndereco,
    inativos,
    completo
  };
  if (vinculo) query["vinculo"] = vinculo;
  return globalThis.window.$axios
    .get({
      url: `${baseURL}/DetalhePrestador`,
      query
    })
    .then(resp => resp.data)
    .catch(error => {
      globalThis.window.$log.error("DetalhePrestador", error.message);
      return error;
    });
}

export async function ObterDadosUsuario({ vinculo }) {
  return globalThis.window.$axios
    .get({
      url: `${baseURL}/ObterDadosUsuario`,
      query: {
        vinculo
      }
    })
    .then(resp => resp.data)
    .catch(error => {
      globalThis.window.$log.error("ObterDadosUsuario", error.message);
      return error;
    });
}

export async function ObterPlanos() {
  return globalThis.window.$axios
    .get({
      url: `${baseURL}/ObterPlanos`
    })
    .then(resp => resp.data)
    .catch(error => {
      globalThis.window.$log.error("ObterPlanos", error.message);
      return error;
    });
}

export async function ObterRedes() {
  return globalThis.window.$axios
    .get({
      url: `${baseURL}/ObterRedes`
    })
    .then(resp => resp.data)
    .catch(error => {
      globalThis.window.$log.error("ObterRedes", error.message);
      return error;
    });
}

export async function ObterTipoAtendimento({ vinculo, rede }) {
  const query = { rede };
  if (vinculo) query["vinculo"] = vinculo;
  return globalThis.window.$axios
    .get({
      url: `${baseURL}/ObterTipoAtendimento`,
      query
    })
    .then(resp => resp.data)
    .catch(error => {
      globalThis.window.$log.error("ObterTipoAtendimento", error.message);
      return error;
    });
}

export async function ObterEspecialidades({ vinculo, codigoCategoria }) {
  const query = {};
  if (vinculo) query["vinculo"] = vinculo;
  return globalThis.window.$axios
    .get({
      url: `${buscaRedebaseURL}/categorias/${codigoCategoria}`,
      query
    })
    .then(resp => resp.data)
    .catch(error => {
      globalThis.window.$log.error("ObterEspecialidades", error.message);
      return error;
    });
}

export async function ObterSubEspecialidades({ vinculo, rede, tipoAtendimento, inativos, codigoEspecialidade }) {
  const query = {
    rede,
    tipoAtendimento,
    inativos,
    codigoEspecialidade
  };
  if (vinculo) query["vinculo"] = vinculo;
  return globalThis.window.$axios
    .get({
      url: `${baseURL}/ObterSubEspecialidades`,
      query
    })
    .then(resp => resp.data)
    .catch(error => {
      globalThis.window.$log.error("ObterSubEspecialidades", error.message);
      return error;
    });
}

export async function ObterPlanosAtendidos({ vinculo, rede, codigoPrestador }) {
  const query = {
    rede,
    codigoPrestador
  };
  if (vinculo) query["vinculo"] = vinculo;
  return globalThis.window.$axios
    .get({
      url: `${baseURL}/ObterPlanosAtendidos`,
      query
    })
    .then(resp => resp.data)
    .catch(error => {
      globalThis.window.$log.error("ObterPlanosAtendidos", error.message);
      return error;
    });
}

export async function ObterPrestadoresSubstitutos({ vinculo, rede, codigoPrestador, srEndereco }) {
  return globalThis.window.$axios
    .get({
      url: `${baseURL}/ObterPrestadoresSubstitutos`,
      query: {
        vinculo,
        rede,
        codigoPrestador,
        srEndereco
      }
    })
    .then(resp => resp.data)
    .catch(error => {
      globalThis.window.$log.error("ObterPrestadoresSubstitutos", error.message);
      return error;
    });
}

export async function ObterRegioes({
  vinculo,
  rede,
  tipoAtendimento,
  codigoEspecialidade,
  subEspecialidade,
  inativos
}) {
  const query = {
    rede,
    tipoAtendimento,
    codigoEspecialidade,
    subEspecialidade,
    inativos
  };
  if (vinculo) query["vinculo"] = vinculo;
  return globalThis.window.$axios
    .get({
      url: `${baseURL}/ObterRegioes`,
      query
    })
    .then(resp => resp.data)
    .catch(error => {
      globalThis.window.$log.error("ObterRegioes", error.message);
      return error;
    });
}

export async function BuscarHistoricoAcesso({ vinculo }) {
  return globalThis.window.$axios
    .get({
      url: `${baseURL}/BuscarHistoricoAcesso`,
      query: {
        vinculo
      }
    })
    .then(resp => resp.data)
    .catch(error => {
      globalThis.window.$log.error("BuscarHistoricoAcesso", error.message);
      return error;
    });
}

export async function RegistrarAcesso({ vinculo, prestador, endereco }) {
  return globalThis.window.$axios
    .post({
      url: `${baseURL}/RegistrarAcesso`,
      query: {
        vinculo,
        prestador,
        endereco
      }
    })
    .then(resp => resp.data)
    .catch(error => {
      globalThis.window.$log.error("RegistrarAcesso", error.message);
      return error;
    });
}

export async function VerificarFavorito({ vinculo, prestador, endereco }) {
  return globalThis.window.$axios
    .get({
      url: `${baseURL}/VerificarFavorito`,
      query: {
        vinculo,
        prestador,
        endereco
      }
    })
    .then(resp => resp.data)
    .catch(error => {
      globalThis.window.$log.error("VerificarFavorito", error.message);
      return error;
    });
}

export async function BuscarFavoritos({ vinculo }) {
  return globalThis.window.$axios
    .get({
      url: `${baseURL}/BuscarFavoritos`,
      query: {
        vinculo
      }
    })
    .then(resp => resp.data)
    .catch(error => {
      globalThis.window.$log.error("BuscarFavoritos", error.message);
      return error;
    });
}

export async function AdicionarFavorito({ vinculo, prestador, endereco }) {
  return globalThis.window.$axios
    .post({
      url: `${baseURL}/AdicionarFavorito`,
      query: {
        vinculo,
        prestador,
        endereco
      }
    })
    .then(resp => resp.data)
    .catch(error => {
      globalThis.window.$log.error("AdicionarFavorito", error.message);
      return error;
    });
}

export async function SalvarFavorito({ vinculo, prestador, endereco }) {
  return window.$axios
    .post({
      url: `${buscaRedebaseURL}/favoritos`,
      query: null,
      data: {
        Vinculo: vinculo,
        CodigoPrestador: prestador,
        CodigoEndereco: endereco
      }
    })
    .then(resp => resp.data)
    .catch(error => {
      globalThis.window.$log.error("AdicionarFavorito", error.message);
      return error;
    });
}

export async function DeletarFavorito({ vinculo, codigoPrestador }) {
  return window.$axios
    .post({
      url: `${buscaRedebaseURL}/favoritos`,
      query: {
        CodigoPrestador: codigoPrestador
      },
      data: {
        Vinculo: vinculo
      }
    })
    .then(resp => resp.data)
    .catch(error => {
      window.$log.error("DeletarFavorito", error.message);
      return error;
    });
}

export async function RemoverFavorito({ vinculo, prestador, endereco }) {
  return globalThis.window.$axios
    .post({
      url: `${baseURL}/RemoverFavorito`,
      query: {
        vinculo,
        prestador,
        endereco
      }
    })
    .then(resp => resp.data)
    .catch(error => {
      globalThis.window.$log.error("RemoverFavorito", error.message);
      return error;
    });
}

export async function PedidosIndicacaoRede({ vinculo }) {
  return globalThis.window.$axios
    .get({
      url: `${baseURL}/PedidosIndicacaoRede`,
      query: {
        vinculo
      }
    })
    .then(resp => resp.data)
    .catch(error => {
      globalThis.window.$log.error("PedidosIndicacaoRede", error.message);
      return error;
    });
}

export async function ResultadoIndicacaoRede({ vinculo, chamado, latitude, longitude }) {
  return globalThis.window.$axios
    .get({
      url: `${baseURL}/ResultadoIndicacaoRede`,
      query: {
        vinculo,
        chamado,
        latitude,
        longitude
      }
    })
    .then(resp => resp.data)
    .catch(error => {
      globalThis.window.$log.error("ResultadoIndicacaoRede", error.message);
      return error;
    });
}

export async function PodeSimularCopay({ vinculo }) {
  return globalThis.window.$axios
    .get({
      url: `${baseURL}/PodeSimularCopay`,
      query: {
        vinculo
      }
    })
    .then(resp => resp.data)
    .catch(error => {
      globalThis.window.$log.error("PodeSimularCopay", error.message);
      return error;
    });
}

export async function ObterSimulacoesCopay({ vinculo }) {
  return globalThis.window.$axios
    .get({
      url: `${baseURL}/ObterSimulacoesCopay`,
      query: {
        vinculo
      }
    })
    .then(resp => resp.data)
    .catch(error => {
      globalThis.window.$log.error("ObterSimulacoesCopay", error.message);
      return error;
    });
}

export async function ObterSimulacaoCopay({ vinculo, id }) {
  return globalThis.window.$axios
    .post({
      url: `${baseURL}/ObterSimulacaoCopay`,
      query: {
        vinculo
      },
      data: {
        id
      }
    })
    .then(resp => resp.data)
    .catch(error => {
      globalThis.window.$log.error("ObterSimulacaoCopay", error.message);
      return error;
    });
}

export async function AceiteTermoSimualacaoCopay({ vinculo }) {
  return globalThis.window.$axios
    .post({
      url: `${baseURL}/AceiteTermoSimualacaoCopay`,
      query: {
        vinculo
      }
    })
    .then(resp => resp.data)
    .catch(error => {
      globalThis.window.$log.error("AceiteTermoSimualacaoCopay", error.message);
      return error;
    });
}

export async function ObterTermoSimualacaoCopay({ vinculo }) {
  return globalThis.window.$axios
    .get({
      url: `${baseURL}/ObterTermoSimualacaoCopay`,
      query: {
        vinculo
      }
    })
    .then(resp => resp.data)
    .catch(error => {
      globalThis.window.$log.error("ObterTermoSimualacaoCopay", error.message);
      return error;
    });
}

export async function ObterExamesProcuradosSimulacaoCopay({ vinculo, incluirTermos }) {
  return globalThis.window.$axios
    .post({
      url: `${baseURL}/ObterExamesProcuradosSimulacaoCopay`,
      query: {
        vinculo
      },
      data: {
        incluirTermos
      }
    })
    .then(resp => resp.data)
    .catch(error => {
      globalThis.window.$log.error("ObterExamesProcuradosSimulacaoCopay", error.message);
      return error;
    });
}

export async function ListarExameSimulacaoCopay({ vinculo, exame }) {
  return globalThis.window.$axios
    .get({
      url: `${baseURL}/ListarExameSimulacaoCopay`,
      query: {
        vinculo,
        exame
      }
    })
    .then(resp => resp.data)
    .catch(error => {
      globalThis.window.$log.error("ListarExameSimulacaoCopay", error.message);
      return error;
    });
}

export async function ExameGrupoCopay({ vinculo, grupo }) {
  return globalThis.window.$axios
    .get({
      url: `${baseURL}/ExameGrupoCopay`,
      query: {
        vinculo,
        grupo
      }
    })
    .then(resp => resp.data)
    .catch(error => {
      globalThis.window.$log.error("ExameGrupoCopay", error.message);
      return error;
    });
}

export async function SinonimosExameCopay({ vinculo, exame }) {
  return globalThis.window.$axios
    .get({
      url: `${baseURL}/SinonimosExameCopay`,
      query: {
        vinculo,
        exame
      }
    })
    .then(resp => resp.data)
    .catch(error => {
      globalThis.window.$log.error("SinonimosExameCopay", error.message);
      return error;
    });
}

export async function ObterPrestadoresProcuradosSimulacaoCopay({ vinculo, exames, tipoEndereco, incluirTermos }) {
  let coords: any = null;
  if (!tipoEndereco || (tipoEndereco !== "C" && tipoEndereco !== "R")) {
    tipoEndereco = "";
    coords = await geoUtils.GetLocation().catch(() => null);
  }
  return globalThis.window.$axios
    .post({
      url: `${baseURL}/ObterPrestadoresProcuradosSimulacaoCopay`,
      query: {
        vinculo
      },
      data: {
        exames,
        tipoEndereco,
        latitude: coords?.latitude,
        longitude: coords?.longitude,
        incluirTermos
      }
    })
    .then(resp => resp.data)
    .catch(error => {
      globalThis.window.$log.error("ObterPrestadoresProcuradosSimulacaoCopay", error.message);
      return error;
    });
}

export async function BuscarPrestadorSimulacaoCopay({ vinculo, exames, tipoEndereco, nome }) {
  let coords: any = null;
  if (!tipoEndereco || (tipoEndereco !== "C" && tipoEndereco !== "R")) {
    tipoEndereco = "";
    coords = await geoUtils.GetLocation().catch(() => null);
  }
  return globalThis.window.$axios
    .post({
      url: `${baseURL}/BuscarPrestadorSimulacaoCopay`,
      query: {
        vinculo
      },
      data: {
        nome,
        exames,
        tipoEndereco,
        latitude: coords?.latitude,
        longitude: coords?.longitude
      }
    })
    .then(resp => resp.data)
    .catch(error => {
      globalThis.window.$log.error("BuscarPrestadorSimulacaoCopay", error.message);
      return error;
    });
}

export async function SimularCopay({ vinculo, exames, prestadores }) {
  return globalThis.window.$axios
    .post({
      url: `${baseURL}/SimularCopay`,
      query: {
        vinculo
      },
      data: {
        exames,
        prestadores
      }
    })
    .then(resp => resp.data)
    .catch(error => {
      globalThis.window.$log.error("SimularCopay", error.message);
      return error;
    });
}

export async function ObterModeloCopay({ vinculo }) {
  return globalThis.window.$axios
    .get({
      url: `${baseURL}/ObterModeloCopay`,
      query: {
        vinculo
      }
    })
    .then(resp => resp.data)
    .catch(error => {
      globalThis.window.$log.error("ObterModeloCopay", error.message);
      return error;
    });
}

export async function ObterNovosAvisosDescredenciamento({ vinculo }) {
  return globalThis.window.$axios
    .get({
      url: `${baseURL}/ObterNovosAvisosDescredenciamento`,
      query: {
        vinculo
      }
    })
    .then(resp => resp.data)
    .catch(error => {
      globalThis.window.$log.error("ObterNovosAvisosDescredenciamento", error.message);
      return error;
    });
}

export async function RegistrarCienteAvisoDescredenciamento({ vinculo, prestador, endereco }) {
  return globalThis.window.$axios
    .post({
      url: `${baseURL}/RegistrarCienteAvisoDescredenciamento`,
      query: {
        vinculo
      },
      data: {
        prestador,
        endereco
      }
    })
    .then(resp => resp.data)
    .catch(error => {
      globalThis.window.$log.error("RegistrarCienteAvisoDescredenciamento", error.message);
      return error;
    });
}

export async function BuscarPrestadorViaChat({ message, imageDataUrl }) {
  const vinculo = getStorageData("vinculo", "");

  return globalThis.window.$axios
    .post({
      url: `${baseURL}/BuscarPrestadorViaChat`,
      query: {
        vinculo
      },
      data: {
        message,
        imageDataUrl: imageDataUrl ?? null
      }
    })
    .then(resp => resp.data)
    .catch(error => {
      globalThis.window.$log.error("BuscarPrestadorViaChat", error.message);
      return error;
    });
}

export async function buscaDeRedeHome({ vinculo }) {
  return window.$axios
    .get({
      url: `${buscaRedebaseURL}/home`,
      query: {
        vinculo
      }
    })
    .then(resp => resp.data)
    .catch(error => {
      window.$log.error("buscaDeRedeHome", error.message);
      return error;
    });
}

async function getListaV2(url: string, query: Record<string, unknown>): Promise<any[]> {
  const resp = await window.$axios
    .get({ url, query })
    .then(r => r.data)
    .catch(error => {
      window.$log.error("getListaV2", error.message);
      return null;
    });
  const data = resp && !(resp instanceof Error) ? resp.Data : null;
  return Array.isArray(data) ? data : [];
}

async function carregarListaCompletaV2(p): Promise<any[]> {
  const termo = p.termo;
  const vinculo = p.vinculo;
  let lista: any[];
  if (termo) {
    // Intenção: busca por texto (nome). Ignora especialidade/região/lat-long.
    lista = await getListaV2(`${buscaRedebaseURL}/busca/termo`, { vinculo, termo });
  } else if (p.latitude && p.longitude) {
    // Intenção: por especialidade "perto de mim" (servidor ordena por distância).
    lista = await getListaV2(`${buscaRedebaseURL}/busca/especialidade`, {
      vinculo,
      tipoAtendimento: p.tipoAtendimento,
      codigoEspecialidade: p.codigoEspecialidade,
      rede: p.rede,
      latitude: p.latitude,
      longitude: p.longitude
    });
  } else if (p.codigoEstado || p.cidade || p.bairro) {
    // Intenção: por região (cidade/estado).
    lista = await getListaV2(`${buscaRedebaseURL}/busca/regiao`, {
      vinculo,
      tipoAtendimento: p.tipoAtendimento,
      codigoEspecialidade: p.codigoEspecialidade,
      rede: p.rede,
      estado: p.codigoEstado,
      cidade: p.cidade,
      bairro: p.bairro
    });
  } else {
    // Especialidade sem localização: mesma rota, sem lat/long (ordem alfabética no servidor).
    lista = await getListaV2(`${buscaRedebaseURL}/busca/especialidade`, {
      vinculo,
      tipoAtendimento: p.tipoAtendimento,
      codigoEspecialidade: p.codigoEspecialidade,
      rede: p.rede
    });
  }

  return lista;
}

function montarFiltrosDisponiveis(lista: any[], p): any[] {
  const filtros: any[] = [];

  if (lista.some(x => x.Telemedicina)) {
    filtros.push({ Codigo: "telemedicina", Titulo: "Telemedicina", Tipo: "boolean" });
  }

  const selSub = new Set<string>(
    (p.codigoSubEspecialidade || "")
      .split(",")
      .map(s => s.trim())
      .filter(Boolean)
  );
  const subMap = new Map<string, string>();
  lista.forEach(x =>
    (x.SubEspecialidades || []).forEach(se => {
      if (se && se.Codigo && se.Titulo && !subMap.has(se.Codigo)) subMap.set(se.Codigo, se.Titulo);
    })
  );
  if (subMap.size) {
    filtros.push({
      Codigo: "subespecialidade",
      Titulo: "Subespecialidade",
      Tipo: "lista",
      Opcoes: Array.from(subMap, ([Codigo, Titulo]) => ({ Codigo, Titulo, Selecionado: selSub.has(Codigo) })).sort(
        (a, b) => a.Titulo.localeCompare(b.Titulo)
      )
    });
  }

  const idiomas = new Set<string>();
  lista.forEach(x => (x.Idiomas || []).forEach(i => i && idiomas.add(String(i).trim())));
  if (idiomas.size) {
    filtros.push({
      Codigo: "idioma",
      Titulo: "Idioma",
      Tipo: "lista",
      Opcoes: Array.from(idiomas)
        .sort((a, b) => a.localeCompare(b))
        .map(i => ({ Codigo: i, Titulo: i, Selecionado: false }))
    });
  }

  return filtros;
}

function montarOrdenacoesDisponiveis(ordenacao) {
  const atual = String(ordenacao || "distancia").toLowerCase();
  return [
    { Codigo: "distancia", Titulo: "Distância", Selecionado: atual === "distancia" },
    { Codigo: "recomendacaoOmint", Titulo: "Recomendação Omint", Selecionado: atual === "recomendacaoomint" },
    { Codigo: "redeOmint", Titulo: "Rede Omint", Selecionado: atual === "redeomint" }
  ];
}

export async function obterResultados(params, vinculo) {
  const { pagina = 1, tamanhoPagina = 20, usarLocalizacaoAtual } = params;
  const p = { ...params, vinculo };

  const hasLatitude = p.latitude !== null && p.latitude !== undefined;
  const hasLongitude = p.longitude !== null && p.longitude !== undefined;

  // Evita segunda chamada de geolocalização quando lat/long já vieram do searchProviders
  if (usarLocalizacaoAtual && !(hasLatitude && hasLongitude)) {
    const coords: any = await geoUtils.GetLocation().catch(() => null);
    if (coords) {
      p.latitude = coords.latitude;
      p.longitude = coords.longitude;
    }
  }

  // Sem cache de front: toda busca chama a API. O cache fica por conta do Redis no backend (procs cacheadas).
  // Os filtros de TELA (subespecialidade/telemedicina/nomePrestador) são aplicados sobre a lista recém-carregada.
  const listaCompleta = await carregarListaCompletaV2(p);

  const filtrosDisponiveis = montarFiltrosDisponiveis(listaCompleta, p);

  // SEM filtro e SEM paginação no adapter: subespecialidade/telemedicina/idioma/rede/nome/ordenação são
  // filtros de TELA, aplicados 100% client-side no doctors-list sobre a lista completa. O adapter entrega tudo.
  return {
    Data: {
      Prestadores: listaCompleta,
      Total: listaCompleta.length,
      TotalBusca: listaCompleta.length,
      Pagina: pagina,
      TamanhoPagina: tamanhoPagina,
      Rede: p.rede || "",
      TipoAtendimento: p.tipoAtendimento || "",
      CodigoEspecialidade: p.codigoEspecialidade || "",
      Termo: p.termo || "",
      Ordenacao: p.ordenacao || "Distancia",
      FiltrosDisponiveis: filtrosDisponiveis,
      FiltrosAplicados: {
        Termo: p.termo || "",
        Telemedicina: p.telemedicina === true || p.telemedicina === "true",
        CodigoSubEspecialidade: p.codigoSubEspecialidade || "",
        NomePrestador: p.nomePrestador || "",
        Facilidades: [],
        Idiomas: []
      },
      OrdenacoesDisponiveis: montarOrdenacoesDisponiveis(p.ordenacao)
    }
  };
}

export async function GuardarBusca({ vinculo, termo }: { vinculo: string; termo: string }) {
  return window.$axios
    .post({
      url: `${buscaRedebaseURL}/historico`,
      data: {
        Vinculo: vinculo,
        Termo: termo
      }
    })
    .then(resp => resp.data)
    .catch(error => {
      window.$log.error("GuardarBusca", error.message);
      return error;
    });
}

export async function obterEnderecosBusca({ vinculo }) {
  return window.$axios
    .get({
      url: `${buscaRedebaseURL}/enderecos-busca`,
      query: {
        vinculo
      }
    })
    .then(resp => resp.data)
    .catch(error => {
      window.$log.error("obterEnderecosBusca", error.message);
      return error;
    });
}

export async function ObterDetalhesPrestador({ vinculo, prestador, endereco }) {
  return window.$axios
    .get({
      url: `${buscaRedebaseURL}/prestadores/${prestador}/enderecos/${endereco}`,
      query: {
        vinculo
      }
    })
    .then(resp => resp.data)
    .catch(error => {
      window.$log.error("ObterDetalhesPrestador", error.message);
      return error;
    });
}

export async function BuscarCidade({
  vinculo,
  estado,
  tipoAtendimento = "",
  codigoEspecialidade = ""
}: {
  vinculo: string;
  estado?: string;
  tipoAtendimento?: string;
  codigoEspecialidade?: string;
}) {
  return window.$axios
    .get({
      url: `${buscaRedebaseURL}/cidades`,
      query: {
        vinculo,
        estado,
        tipoAtendimento,
        codigoEspecialidade
      }
    })
    .then(resp => resp.data)
    .catch(error => {
      window.$log.error("BuscarCidade", error.message);
      return error;
    });
}

export async function BuscarEstados({ vinculo = "", tipoAtendimento = "", codigoEspecialidade = "" } = {}) {
  return window.$axios
    .get({
      url: `${buscaRedebaseURL}/estados`,
      query: {
        vinculo,
        tipoAtendimento,
        codigoEspecialidade
      }
    })
    .then(resp => resp.data)
    .catch(error => {
      window.$log.error("BuscarEstados", error.message);
      return error;
    });
}

export async function ObterPlanosPrestador({
  vinculo,
  prestador,
  rede
}: {
  vinculo: string;
  prestador: string;
  rede: string;
}) {
  return window.$axios
    .get({
      url: `${buscaRedebaseURL}/prestadores/${prestador}/planos`,
      query: {
        vinculo,
        rede
      }
    })
    .then(resp => resp.data)
    .catch(error => {
      window.$log.error("ObterPlanosPrestador", error.message);

      return error;
    });
}
